import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Modal from '../../components/Modal';
import {deleteContact} from '../../actions/ClientActions';

@connect(
    state => ({
        isSaving: state.modal.isSaving
    }),
    dispatch => bindActionCreators({deleteContact}, dispatch)
)
export default class ConfirmDeleteContactModal extends React.Component {
    handleDelete() {
        this.props.deleteContact(this.props.contact.id);
    }
    render() {
        var actionButton = this.props.isSaving ?
            (<button className="btn btn-danger disabled">Deleting...</button>) :
            (<button className="btn btn-danger" onClick={this.handleDelete.bind(this)}>Delete</button>);

        return (
            <Modal actionButton={actionButton} className="modal-danger" title={"Confirm you would like to delete contact"}>
                <p>Are you sure you would like to delete <strong>{this.props.contact.firstName} {this.props.contact.lastName}</strong></p>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/ConfirmDeleteContactModal.js